import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import GroupCard from './GroupCard';
import React, { useState, useEffect } from 'react';
import CreateGroupPage from '../CreatePages/CreateGroupPage';
import { useNavigate } from 'react-router-dom';

import Plus from '../media/imagen/Plus.png'  

const GroupsPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showCreateGroupForm, setShowCreateGroupForm] = useState(false);
  const [groups, setGroups] = useState([]);
  const [userCompanyId, setUserCompanyId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOption, setSortOption] = useState('none'); // 'none', 'newest', 'oldest'
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);
  const navigate = useNavigate();

  // Функция загрузки company_id пользователя
  const fetchCompanyId = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('http://185.250.149.189:8000/api/v1/Company', {
        headers: { 'Authorization': `Token ${token}` }
      });
      
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      
      const data = await response.json();
      return data.Company?.id || null;
    } catch (error) {
      console.error('Ошибка загрузки компании:', error);
      setError('Не удалось загрузить информацию о компании');
      return null;
    }
  };

  // Функция загрузки групп
  const fetchGroups = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('Токен авторизации не найден');
        return [];
      }

      const response = await fetch('http://185.250.149.189:8000/api/v1/GroupUsers', {
        method: 'GET',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
      
      const data = await response.json();
      console.log(data);
      return data.groups_users || [];
    } catch (error) {
      console.error('Ошибка при получении групп:', error);
      setError('Не удалось загрузить группы');
      return [];
    }
  };

  // Загрузка всех данных
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        // Загружаем данные параллельно
        const [companyId, groupsData] = await Promise.all([
          fetchCompanyId(),
          fetchGroups()
        ]);
        
        setUserCompanyId(companyId);
        setGroups(groupsData);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        setError('Произошла ошибка при загрузке данных');
      } finally {
        setIsLoading(false);
      }
    };
    
    loadData();
  }, []);

  // Фильтрация групп по company_id
  const filteredGroups = userCompanyId === 1 
    ? groups 
    : groups.filter(group => group.company_id === userCompanyId);

  // Фильтрация по поисковому запросу
  const filterBySearch = (groups) => {
    if (!searchQuery.trim()) return groups;
    
    const queryWords = searchQuery.toLowerCase().split(/\s+/);
    
    return groups.filter(group => {
      const name = group.name?.toLowerCase() || '';
      const users = group.users?.map(user => user.user_name?.toLowerCase() || '').join(' ') || '';
      
      // Проверяем, что все слова из запроса присутствуют в названии или именах пользователей
      return queryWords.every(word => 
        name.includes(word) || 
        users.includes(word)
      );
    });
  };

  // Сортировка групп
  const sortGroups = (groups) => {
    if (sortOption === 'none') return [...groups];
    
    return [...groups].sort((a, b) => {
      const dateA = new Date(a.date_create);
      const dateB = new Date(b.date_create);
      
      return sortOption === 'newest' 
        ? dateB - dateA 
        : dateA - dateB;
    });
  };

  // Применяем фильтрацию и сортировку
  const filteredBySearch = filterBySearch(filteredGroups);
  const filteredAndSortedGroups = sortGroups(filteredBySearch);

  // Обработчик поиска
  const handleSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      setIsSearchActive(true);
    }
  };

  // Обработчик сброса поиска
  const handleClearSearch = () => {
    setSearchQuery('');
    setIsSearchActive(false);
  };

  // Обработчик создания новой группы
  const handleCreateGroup = () => {
    setShowCreateGroupForm(true);
  };

  // Обработчик успешного сохранения группы
  const handleSaveSuccess = () => {
    setShowCreateGroupForm(false);
    // Перезагружаем группы после создания
    const reloadGroups = async () => {
      setIsLoading(true);
      try {
        setGroups(await fetchGroups());
      } catch (error) {
        console.error('Ошибка перезагрузки групп:', error);
      } finally {
        setIsLoading(false);
      }
    };
    reloadGroups();
  };

  // Обработчик редактирования группы
  const handleEditGroup = (group) => {
    navigate(`/edit-group/${group.id}`);
  };

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} 
      />
      <TopBar isCollapsed={isSidebarCollapsed} />  
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="content-container">
          {showCreateGroupForm ? (
            <CreateGroupPage onSaveSuccess={handleSaveSuccess} />
          ) : (
            <>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '30px' 
              }}>
                <h1>Управление группами</h1>
                <button 
                  className="add-button"
                  onClick={handleCreateGroup}
                >
                  Создать новую группу
                  <img src={Plus} alt='Plus' />
                </button>
              </div>
{/* Панель поиска и сортировки */}
<div style={{ 
  display: 'flex', 
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0px',
  gap: '24px',
  width: '100%',
  height: '36px',
  background: '#E9EFF9',
  marginBottom: '20px',
  boxSizing: 'border-box'
}}>
  {/* Поле поиска */}
  <div style={{
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '9px 12px',
    gap: '10px',
    width: '889px',
    height: '36px',
    border: '1px solid #CCD3DE',
    borderRadius: '8px',
    background: 'transparent',
    position: 'relative'
  }}>
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '0px',
      gap: '8px',
      width: '100%',
      height: '18px'
    }}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 10H11.09L10.94 9.85C11.57 9.06 12 8.06 12 7C12 4.79 10.21 3 8 3C5.79 3 4 4.79 4 7C4 9.21 5.79 11 8 11C9.06 11 10.06 10.57 10.85 9.94L11 10.09V10.5L14 13.49L14.99 12.5L11.5 10ZM8 10C6.34 10 5 8.66 5 7C5 5.34 6.34 4 8 4C9.66 4 11 5.34 11 7C11 8.66 9.66 10 8 10Z" fill="#14151A"/>
      </svg>
      <input
        type="text"
        placeholder="Введите название группы или участника"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyPress={handleSearch}
        style={{
          width: '100%',
          height: '18px',
          border: 'none',
          outline: 'none',
          fontFamily: 'Montserrat, sans-serif',
          fontStyle: 'normal',
          fontWeight: 500,
          fontSize: '13px',
          lineHeight: '18px',
          letterSpacing: '-0.0008em',
          color: '#8C96A8',
          background: 'transparent'
        }}
      />
    </div>
    
    {isSearchActive && (
      <div 
        onClick={handleClearSearch}
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          cursor: 'pointer',
          color: '#7F8C8D',
          fontSize: '18px'
        }}
      >
        ×
      </div>
    )}
  </div>
  
  {/* Выпадающий список сортировки */}
  <div style={{
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 8px 8px 12px',
    gap: '8px',
    width: '191px',
    height: '34px',
    border: '1px solid #CCD3DE',
    borderRadius: '8px',
    background: 'transparent',
    position: 'relative'
  }}>
    <select 
      value={sortOption}
      onChange={(e) => setSortOption(e.target.value)}
      style={{
        width: '100%',
        border: 'none',
        outline: 'none',
        fontFamily: 'Montserrat, sans-serif',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '13px',
        lineHeight: '18px',
        letterSpacing: '-0.0008em',
        color: '#14151A',
        appearance: 'none',
        background: 'transparent',
        cursor: 'pointer'
      }}
    >
      <option value="none">Сортировать по дате</option>
      <option value="newest">Сначала новые</option>
      <option value="oldest">Сначала старые</option>
    </select>
    <div style={{
      position: 'absolute',
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none'
    }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 9L12 15L18 9" stroke="#272727" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  </div>
</div>
              
              {error && (
                <div className="error-message">{error}</div>
              )}
              
              {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px 0' }}>
                  <p>Загрузка данных...</p>
                </div>
              ) : (
                <>
                  {/* Контейнер с карточками групп */}
                  <div className="group-cards-container">
                    {filteredAndSortedGroups.map(group => (
                      <GroupCard 
                        key={group.id} 
                        group={group} 
                        onEdit={handleEditGroup}
                      />
                    ))}
                  </div>
                  
                  {/* Сообщение если нет групп */}
                  {filteredAndSortedGroups.length === 0 && (
                    <div style={{ textAlign: 'center', padding: '50px 0' }}>
                      <p style={{ fontSize: '18px', color: '#666' }}>
                        {searchQuery
                          ? 'Группы по вашему запросу не найдены'
                          : userCompanyId === 1
                            ? 'Группы не найдены'
                            : 'Группы для вашей компании не найдены'
                        }
                      </p>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default GroupsPage;